"use strict";

import "./ButtonGroup.css";
import React from "react";
import classnames from "classnames";
import Button from "./../Button";

export default class ButtonGroup extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			selected: this.constructor.getSelectedValueByProps(this.props)
		};
	}
	
	static getSelectedValueByProps(props) {
		if (props.multiSelect)
			return new Set(props.selected || []);
		else
			return props.selected || null;
	}
	
	static isTheSameSet(set1, set2) {
		
		let comparisionSet = new Set();
		
		set1.forEach(e => {
			if (set2.has(e)) comparisionSet.add(e)
		});
		
		if (set1.size == comparisionSet.size)
			return true;
		return false;
	}
	
	componentWillReceiveProps(nextProps) {
		let selectedValue = this.constructor.getSelectedValueByProps(this.props);
		let nextSelectedValue = this.constructor.getSelectedValueByProps(nextProps);
		
		if (
			(this.props.multiSelect && !this.constructor.isTheSameSet(selectedValue, nextSelectedValue)) ||
			selectedValue != nextSelectedValue
		) {
			this.setState({
				selected: nextSelectedValue
			});
		}
	}
	
	emitChange() {
		if (this.props.multiSelect)
			this.props.onChange(this.constructor.createArrayFromSet(this.state.selected));
		else
			this.props.onChange(this.state.selected);
	}
	
	static createArrayFromSet(set) {
		let array = [];
		set.forEach(item => array.push(item));
		return array;
	}
	
	canRemoveSelected(id) {
		if (!this.props.required || (this.props.required && this.state.selected.size > 1))
			return true;
		else
			return false;
	}
	
	multiSelect(id) {
		if (this.state.selected.has(id)) {
			if (this.canRemoveSelected(id)) {
				this.state.selected.delete(id);
				this.emitChange();
			}
		}
		else {
			this.state.selected.add(id);
			this.emitChange();
		}
	}
	
	singleSelect(id) {
		if (this.state.selected == id && this.props.required)
			return;
		
		if (this.state.selected == id)
			this.state.selected = null;
		else
			this.state.selected = id;
		
		this.emitChange();
	}
	
	select(id) {
		if (this.props.multiSelect)
			this.multiSelect(id);
		else
			this.singleSelect(id);
		this.setState({});
	}
	
	isButtonSelected(button) {
		if (this.props.multiSelect)
			return this.state.selected.has(button.props.id) ? true : false;
		else
			return this.state.selected == button.props.id ? true : false;
	}
	
	renderButton(button) {
		
		const className = classnames(button.props.className || "", {"Selected": this.isButtonSelected(button)});
		
		return (
			<Button
				key={button.props.id}
				className={className}
				onClick={()=>this.select(button.props.id)}
			>{button.props.children}</Button>
		);
	}
	
	render() {
		return (
			<div className={classnames(this.props.className, "ButtonGroup")}>
				<div>
					{this.props.children.map(child => this.renderButton(child))}
				</div>
			</div>
		);
	}
}

ButtonGroup.propTypes = {
	selected: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.array
	]),
	onChange: React.PropTypes.func,
	required: React.PropTypes.bool,
	multiSelect: React.PropTypes.bool
};

ButtonGroup.defaultProps = {
	onChange: id => {},
	required: false,
	multiSelect: false
};


// WEBPACK FOOTER //
// ./~/vwa/components/ButtonGroup/ButtonGroup.jsx